import Vue from 'vue';
import Vuex, { mapGetters } from 'vuex';
import VueScrollTo from 'vue-scrollto';
import store from './store';
import './../shared/polyfills';
import breakpoints from './utils/breakpoints';
import { sitecore } from './../shared';
import objectFitImages from 'object-fit-images';

import {
	ResetPassword,
	SearchFlyout,
	Expand,
	Overlay,
	SignIn,
} from './../shared/components';

import {
	FilterCheckboxFacet,
	FilterCheckboxItem,
	FilterSearch,
	FilterResult,
	SearchFilterResult,
} from './../shared/components/filter';

import {
	SocialShare,
	Facebook,
	Email,
	Linkedin,
	Twitter,
	WhatsApp,
	Google,
} from './../shared/components/social';

import VueYoutube from 'vue-youtube';
import { TransitionExpand } from './../shared/animations';

Vue.use(VueYoutube);
Vue.use(VueScrollTo, {
  offset: -75
});

const AppBase = (components = {}) => {

  sitecore.init();

  new Vue({
    el: '.wrapper',
    store,
    data: {
			...window.store,
			useLegacy: process.env.LEGACY,
		},
    mounted: function() {
      this.$nextTick(function() {
        const imagesWithObjectFit = document.querySelectorAll('img.object-fit');
        objectFitImages(imagesWithObjectFit);
        breakpoints.listen(this);
        window.addEventListener('scroll', ( event ) => {
          if(!this.isMobileMenuOpened && !this.isSecondNavigationOpened) {
            if(window.scrollY > this.stickyHeight && !this.isSticky) {
              this.$store.dispatch('sticky/setSticky', true);
            } else if(window.scrollY == 0 && this.isSticky) {
              this.$store.dispatch('sticky/setSticky', false);
            }
          }
        });
        //run this for sitecore experience editor
        sitecore.load(Array.from(this.$el.getElementsByTagName('code')));

      });
    },
    methods: {
      toggleMenu: function() {
        this.$store.dispatch('mainnavigation/toggleMobileMenu', { isOpened: !this.isMobileMenuOpened, clicked: true });
      },
      toggleSecondNavigation: function() {
        this.$store.dispatch('secondnavigation/toggleSecondNavigationMenu');
        this.handleOverlay();
      },
      handleOverlay: function() {
        if(this.hasCurrentNavigationItem || this.hasCurrentNavigation || this.isSecondNavigationOpened) {
					const callback = this.isSecondNavigationOpened ? this.toggleSecondNavigation : () => {
						this.setCurrentNavigationItem(null);
					};
          this.$store.dispatch('overlay/show', { show: true, cb: callback });
        } else {
          this.$store.dispatch('overlay/hide');
        }
      },
      closeOnOverlay: function() {

        if(this.isOverlayFull) {
          this.$store.dispatch('overlay/show', { show: false });
          return;
        }

        if(this.hasCurrentNavigationItem) {
          this.$store.dispatch('mainnavigation/setCurrentNavigationItem', null);
        } else if(this.hasCurrentNavigation) {
          this.$store.dispatch('secondnavigation/setCurrentNavigation', null);
          if(this.isSecondNavigationOpened) {
            this.toggleSecondNavigation();
          }
        } else if(this.isSecondNavigationOpened && !this.hasCurrentNavigation) {
          this.toggleSecondNavigation();
        }
        this.handleOverlay();
      },
      subNavigationItemToggle: function(currentNavigation) {
        if(this.hasCurrentNavigationItem) {
          this.setCurrentNavigationItem(null);
        }
        this.$store.dispatch('secondnavigation/setCurrentNavigation', currentNavigation);
        this.handleOverlay();
      },
      setCurrentNavigationItem: function(currentNavigationItem) {
        if(this.hasCurrentNavigation) {
          this.$store.dispatch('secondnavigation/setCurrentNavigation', null);
        }
        this.$store.dispatch('mainnavigation/setCurrentNavigationItem', currentNavigationItem);
        this.handleOverlay();
      },
      readMore: function() {
        this.$store.dispatch('readmore/toggleReadMoreText');
      },
      toggleSpecificationList: function() {
        this.$store.dispatch('readmore/toggleSpecificationList');
      },
			toggleSearch: function() {
				if(!this.isSearchOpened) {
					this.$store.dispatch('overlay/show', { show: true, cb: this.closeSearch });
				} else {
					this.$store.dispatch('overlay/hide');
				}
				this.$store.dispatch('search/toggleSearch');
			},
			closeSearch: function() {
				if(this.isSearchOpened) {
					this.$store.dispatch('search/toggleSearch');
				}
			},
			toggleSignIn: function() {
				this.$store.dispatch('signin/show', !this.signInVisible);
			},
			toggleShare: function() {
				this.$store.dispatch('share/show', !this.shareVisible);
			},
			toggleArticlesFilter: function() {
				this.$store.dispatch('articles/show', !this.articlesFilterVisible);
			},
			imageErrorFallback: function(event) {

				const src = !window.HTMLPictureElement ? event.target.src : event.target.currentSrc;

				const sourceElements = event.target.parentElement.getElementsByTagName('source');
				let matchingElements = [];
				for (var i = 0; i < sourceElements.length; i++) {
					const currentSource = sourceElements[i];
					let currentSourceSet = currentSource.getAttribute('srcset');
					if(currentSourceSet.indexOf(src) !== -1) {
						if(currentSourceSet.indexOf(',') !== -1) {
							//just remove speicfic value
							currentSourceSet = currentSourceSet.replace(src, '');
							currentSourceSet = currentSourceSet.replace(',', '');
							currentSourceSet = currentSourceSet.replace(' 2x', '');
							currentSource.setAttribute('srcset', currentSourceSet);
						} else {
							matchingElements.push(currentSource);
						}
					}
				}

				for (var i = 0; i < matchingElements.length; i++) {
					event.target.parentElement.removeChild(matchingElements[i]);
				}

				if(!window.HTMLPictureElement) {
					const nextElement = event.target.parentElement.getElementsByTagName('source')[0];
					let nextImageUrl = '';
					if(nextElement) {
						nextImageUrl = nextElement.getAttribute('srcset');
						if(nextImageUrl.indexOf(',') !== -1) {
							nextImageUrl = nextImageUrl.split(',')[0];
						}
						event.target.src = nextImageUrl;
					} else {
						event.target.src = event.target.getAttribute('data-pfsrc');
					}
				}

			},
    },
    watch: {
      currentMediaQueryName: function(value) {

        const mediaQueries = ['lap', 'desktop'];

        this.$store.dispatch('sticky/setStickyHeight');

        //hide mobile navigation
        if(this.isMobileMenuOpened && !this.hasCurrentNavigationItem && mediaQueries.includes(value)) {
          this.$store.dispatch('mainnavigation/toggleMobileMenu', { isOpened: false, clicked: false });
        }

        if(!this.hasCurrentNavigation && this.isSecondNavigationOpened && mediaQueries.includes(value)) {
          this.toggleSecondNavigation();
        }

        //if a main navigation item is opened and window resizes to handheld and down show mobile menu
        if(this.hasCurrentNavigationItem && !mediaQueries.includes(value) && !this.isMobileMenuOpened) {
            this.$store.dispatch('mainnavigation/toggleMobileMenu', { isOpened: true, clicked: false });
        } else if (this.isMobileMenuOpened && this.hasCurrentNavigationItem &&  mediaQueries.includes(value)) {
          this.$store.dispatch('mainnavigation/toggleMobileMenu', { isOpened: false, clicked: false });
        }

        //If screen size goes from wide to mobile with a current navigation then show second navigation in mobile
        if(this.hasCurrentNavigation && !this.isSecondNavigationOpened && !mediaQueries.includes(value)) {
          this.$store.dispatch('secondnavigation/setShowSecondNavigation', true);

        //if we go back from mobile to wide with opened secondary navigation then reset it
        } else if(this.isSecondNavigationOpened && this.hasCurrentNavigation &&  mediaQueries.includes(value)) {
          this.$store.dispatch('secondnavigation/setShowSecondNavigation', false);
        }
      },
      isSticky: function(isSticky) {
        if(isSticky && this.hasCurrentNavigationItem) {
            this.closeOnOverlay();
        }
      },
			isOverlayHidden: function(overlayHidden) {
				if(overlayHidden && this.isSearchOpened) {
					this.$store.dispatch('search/toggleSearch');
				}
			}
    },
    computed: {
      ...mapGetters({
        currentMediaQueryName: 'mediaqueries/currentMediaQuery',
        isMobileMenuOpened: 'mainnavigation/isMobileMenuOpened',
        isSecondNavigationOpened: 'secondnavigation/isSecondNavigationOpened',
        secondNavigationStyles: 'secondnavigation/secondNavigationStyles',
        hasCurrentNavigation: 'secondnavigation/hasCurrentNavigation',
        hasCurrentNavigationItem: 'mainnavigation/hasCurrentNavigationItem',
        isSticky: 'sticky/isSticky',
        stickyHeight: 'sticky/stickyHeight',
        stickyStyle: 'sticky/stickyStyle',
        showReadMoreText: 'readmore/showReadMoreText',
        showReadMore: 'readmore/showReadMore',
        showSpecificationList: 'readmore/showSpecificationList',
				isSearchOpened: 'search/isOpened',
				shareVisible: 'share/visible',
				articlesFilterVisible: 'articles/visible',
				signInVisible: 'signin/show',
      }),
    },
		components: {
			TransitionExpand,
			ResetPassword,
			FilterCheckboxFacet,
			FilterCheckboxItem,
			FilterSearch,
			FilterResult,
			SearchFilterResult,
			SocialShare,
			Facebook,
			Twitter,
			Linkedin,
			WhatsApp,
			Google,
			Email,
			SearchFlyout,
			Expand,
			Overlay,
			SignIn,
			...components
		}
  });
};

export default AppBase;



// WEBPACK FOOTER //
// ./base.js